import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

var _0ab97ddf = function _0ab97ddf() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _75fc1b3a = function _75fc1b3a() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _557d3391 = function _557d3391() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _cd8ca082 = function _cd8ca082() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _a6410bf4 = function _a6410bf4() {
  return interopDefault(import('../pages/_market/_language/cart/index.vue'
  /* webpackChunkName: "pages/_market/_language/cart/index" */
  ));
};

var _4e83d8e7 = function _4e83d8e7() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _015de0d9 = function _015de0d9() {
  return interopDefault(import('../pages/_market/_language/login/index.vue'
  /* webpackChunkName: "pages/_market/_language/login/index" */
  ));
};

var _46c4c458 = function _46c4c458() {
  return interopDefault(import('../pages/_market/_language/lost-password/index.vue'
  /* webpackChunkName: "pages/_market/_language/lost-password/index" */
  ));
};

var _4cd01982 = function _4cd01982() {
  return interopDefault(import('../pages/_market/_language/reset-password/index.vue'
  /* webpackChunkName: "pages/_market/_language/reset-password/index" */
  ));
};

var _6624933e = function _6624933e() {
  return interopDefault(import('../pages/_market/_language/signup/index.vue'
  /* webpackChunkName: "pages/_market/_language/signup/index" */
  ));
};

var _63c85de5 = function _63c85de5() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _a37f924c = function _a37f924c() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _74415e1e = function _74415e1e() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _7f4d76d6 = function _7f4d76d6() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _b137f9fe = function _b137f9fe() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _bfdfc658 = function _bfdfc658() {
  return interopDefault(import('../pages/_market/_language/poc/grid.vue'
  /* webpackChunkName: "pages/_market/_language/poc/grid" */
  ));
};

var _0920f352 = function _0920f352() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _66cdc51f = function _66cdc51f() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _0325d38b = function _0325d38b() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _78cd5fbc = function _78cd5fbc() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _79a25c9e = function _79a25c9e() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue'
  /* webpackChunkName: "pages/_market/_language/t/confirmed" */
  ));
};

var _9cdc7bdc = function _9cdc7bdc() {
  return interopDefault(import('../pages/_market/_language/t/delivery.vue'
  /* webpackChunkName: "pages/_market/_language/t/delivery" */
  ));
};

var _0b1015bb = function _0b1015bb() {
  return interopDefault(import('../pages/_market/_language/t/login.vue'
  /* webpackChunkName: "pages/_market/_language/t/login" */
  ));
};

var _3b8935f6 = function _3b8935f6() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/t/lost-password" */
  ));
};

var _1c269b58 = function _1c269b58() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment" */
  ));
};

var _3871e302 = function _3871e302() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
  ));
};

var _29651722 = function _29651722() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue'
  /* webpackChunkName: "pages/_market/_language/t/refused" */
  ));
};

var _b966e294 = function _b966e294() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue'
  /* webpackChunkName: "pages/_market/_language/t/signup" */
  ));
};

var _ebb8e412 = function _ebb8e412() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _6233294e = function _6233294e() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _76722ef0 = function _76722ef0() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _6c14e90b = function _6c14e90b() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _023e1b5b = function _023e1b5b() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _601e3f2e = function _601e3f2e() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _710d2ee9 = function _710d2ee9() {
  return interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
  ));
};

var _b3415d1c = function _b3415d1c() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _7c246df6 = function _7c246df6() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _589b1d91 = function _589b1d91() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _222649dc = function _222649dc() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _35c71909 = function _35c71909() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _2ea75439 = function _2ea75439() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _1ab6a77f = function _1ab6a77f() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _2df31ad5 = function _2df31ad5() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _45905720 = function _45905720() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _6d8d591e = function _6d8d591e() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _4e2c9627 = function _4e2c9627() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _acd4861a = function _acd4861a() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/p/_alias" */
  ));
};

var _70d8c2eb = function _70d8c2eb() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _4fb42899 = function _4fb42899() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
};

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      window.history.scrollRestoration = 'manual';
    });
  }
}

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  var position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(function (r) {
    return r.components.default.options.scrollToTop !== false;
  })) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(function (r) {
    return r.components.default.options.scrollToTop;
  })) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _0ab97ddf,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _75fc1b3a,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _557d3391,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _cd8ca082,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _a6410bf4,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _4e83d8e7,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _015de0d9,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _46c4c458,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _4cd01982,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _6624933e,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _63c85de5,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _a37f924c,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _74415e1e,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _7f4d76d6,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _b137f9fe,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _bfdfc658,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _0920f352,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _66cdc51f,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _0325d38b,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _78cd5fbc,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _79a25c9e,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/delivery",
      component: _9cdc7bdc,
      name: "market-language-t-delivery"
    }, {
      path: "/:market/:language/t/login",
      component: _0b1015bb,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _3b8935f6,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _1c269b58,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _3871e302,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _29651722,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/signup",
      component: _b966e294,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _ebb8e412,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _6233294e,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _76722ef0,
      children: [{
        path: "",
        component: _6c14e90b,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _023e1b5b,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _601e3f2e,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _710d2ee9,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _b3415d1c,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _7c246df6,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _589b1d91,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _222649dc,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _35c71909,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _2ea75439,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _1ab6a77f,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _2df31ad5,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _45905720,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _6d8d591e,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _4e2c9627,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _acd4861a,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _70d8c2eb,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _4fb42899,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}